(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  if (!customElements.get('announcement-bar')) {
    customElements.define(
      'announcement-bar',
      class extends HTMLElement {
        connectedCallback() {
          const key = 'pp-announce-closed';
          const version = this.dataset.version || '1';
          try {
            const saved = localStorage.getItem(key);
            if (saved && saved !== version) {
              localStorage.removeItem(key);
              document.documentElement.classList.remove('announce-closed');
            }
          } catch (e) {}
          this.querySelector('[data-announce-close]')?.addEventListener('click', () => {
            document.documentElement.classList.add('announce-closed');
            try {
              localStorage.setItem(key, version);
            } catch (e) {}
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["archive-enquiry"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const pick = (name) => {
      const select = document.querySelector('[data-archive-select]');
      if (!select || !name) return;
      const opt = [...select.options].find((o) => o.value === name);
      if (opt) select.value = name;
    };
    document.addEventListener('click', (e) => {
      const a = e.target.closest('[data-archive-pick]');
      if (a) pick(a.dataset.archivePick);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["archive-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('archive-photos')) {
    customElements.define(
      'archive-photos',
      class extends HTMLElement {
        connectedCallback() {
          this.items = [...this.querySelectorAll('[data-extra] [data-full]')];
          this.box = this.querySelector('[data-box]');
          this.img = this.querySelector('[data-box-img]');
          this.count = this.querySelector('[data-box-current]');
          this.i = 0;
          this.querySelectorAll('.archive-story__tile').forEach((tile) => {
            tile.addEventListener('click', () => {
              const idx = this.items.findIndex((x) => x.dataset.full === tile.dataset.full);
              this.open(Math.max(0, idx));
            });
          });
          this.querySelector('[data-box-close]')?.addEventListener('click', () => this.box.close());
          this.querySelector('[data-box-prev]')?.addEventListener('click', () => this.show(this.i - 1));
          this.querySelector('[data-box-next]')?.addEventListener('click', () => this.show(this.i + 1));
          this.box?.addEventListener('click', (e) => {
            if (e.target === this.box) this.box.close();
          });
          this.box?.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') this.show(this.i - 1);
            if (e.key === 'ArrowRight') this.show(this.i + 1);
          });
          let x0 = null;
          this.box?.addEventListener('touchstart', (e) => (x0 = e.touches[0].clientX), { passive: true });
          this.box?.addEventListener('touchend', (e) => {
            if (x0 === null) return;
            const dx = e.changedTouches[0].clientX - x0;
            if (Math.abs(dx) > 40) this.show(this.i + (dx < 0 ? 1 : -1));
            x0 = null;
          });
        }
        open(i) {
          this.show(i);
          this.box.showModal();
        }
        show(i) {
          const n = this.items.length;
          if (!n) return;
          this.i = (i + n) % n;
          const it = this.items[this.i];
          this.img.src = it.dataset.full;
          this.img.alt = it.dataset.alt || '';
          if (this.count) this.count.textContent = this.i + 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    

if (!customElements.get('journal-layout')) {
  class JournalLayout extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.arrange(), { once: true });
      } else {
        this.arrange();
      }
    }
    arrange() {
      if (this.dataset.arranged === 'true') return;
      this.dataset.arranged = 'true';
      const article = this.closest('.pp-journal');
      const first = this.firstElementChild;
      if (!this.dataset.preserveIntro && first && first.tagName === 'P' && !first.querySelector('img,iframe,video')) {
        const intro = article.querySelector('.article-page__intro');
        if (intro) intro.append(first);
      }
      const nodes = Array.from(this.childNodes);
      let content = null;
      for (const node of nodes) {
        if (node.nodeType === 1 && /^(H2|H3)$/.test(node.tagName)) {
          const section = document.createElement('section');
          section.className = 'journal-layout-section';
          const label = document.createElement('div');
          label.className = 'journal-layout-label';
          content = document.createElement('div');
          content.className = 'journal-layout-content';
          this.insertBefore(section, node);
          label.append(node);
          section.append(label, content);
        } else if (node.nodeType === 1 && node.classList.contains('journal-video')) {
          // A video block stands between chapters on its own row.
          content = null;
        } else if (content) {
          content.append(node);
        }
      }

      const templates = Array.from(article.querySelectorAll('template[data-journal-product-images]'));
      for (const group of this.querySelectorAll('.journal-layout-content')) {
        const rows = Array.from(group.children).filter(el => el.classList.contains('journal-editorial-row'));
        if (!rows.length) continue;
        group.closest('.journal-layout-section').classList.add('journal-layout-section--products');
        const grid = document.createElement('div');
        grid.className = 'journal-product-grid';
        rows[0].before(grid);
        for (const row of rows) {
          const image = row.querySelector('img');
          const filename = image ? image.getAttribute('src').split('/').pop().split('?')[0] : '';
          const card = templates.find(t => t.dataset.journalProductImages.split('|').includes(filename));
          if (card) {
            grid.append(card.content.cloneNode(true));
            row.remove();
          } else {
            row.classList.add('journal-product-tile');
            const description = row.querySelector('.journal-editorial-row__text');
            const title = description?.querySelector('strong,b');
            if (title) { const name = document.createElement('p'); name.textContent = title.textContent; description.replaceChildren(name); }
            grid.append(row);
          }
        }
      }
    }
  }
  customElements.define('journal-layout', JournalLayout);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    if (customElements.get('cart-drawer')) return;

    const SECTION = 'cart-drawer';
    const root = () => window.Shopify?.routes?.root || '/';

    class CartDrawer extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-cart-dialog]');
        this.bind();
        this.dialog.addEventListener('cancel', (e) => {
          e.preventDefault();
          this.close();
        });
        this.dialog.addEventListener('keydown', (e) => this.trap(e));
        window.PPCart = this;
        document.addEventListener('submit', (e) => this.onSubmit(e));
        document.addEventListener('click', (e) => {
          const icon = e.target.closest('.site-header__cart');
          if (icon && !e.metaKey && !e.ctrlKey) {
            e.preventDefault();
            this.open(icon);
          }
        });
        this.emit();
      }

      bind() {
        this.querySelectorAll('[data-cart-close]').forEach((b) => b.addEventListener('click', () => this.close()));
        this.querySelectorAll('[data-cart-remove]').forEach((b) =>
          b.addEventListener('click', () => this.change(b.dataset.cartRemove, 0, b))
        );
        this.querySelectorAll('[data-cart-suggest]').forEach((b) =>
          b.addEventListener('click', () => {
            const name = b.closest('li')?.querySelector('.cart-drawer__name')?.textContent;
            this.add({ items: [{ id: Number(b.dataset.cartSuggest), quantity: 1 }] }, name, b);
          })
        );
      }

      state() {
        try {
          return JSON.parse(this.querySelector('[data-cart-state]').textContent);
        } catch (e) {
          return null;
        }
      }

      emit() {
        const s = this.state();
        if (!s) return;
        document.querySelectorAll('.site-header__cart').forEach((link) => {
          let badge = link.querySelector('.site-header__cart-count');
          if (s.count > 0) {
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'site-header__cart-count';
              badge.setAttribute('aria-hidden', 'true');
              link.appendChild(badge);
            }
            badge.textContent = s.count;
          } else if (badge) badge.remove();
          link.setAttribute('aria-label', `Cart, ${s.count} ${s.count === 1 ? 'item' : 'items'}`);
        });
        document.dispatchEvent(new CustomEvent('pp:cart', { detail: s }));
      }

      onSubmit(e) {
        const form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        const action = form.getAttribute('action') || '';
        if (!/\/cart\/add\/?$/.test(action) || form.hasAttribute('data-no-drawer')) return;
        e.preventDefault();
        const submit = form.querySelector('[type="submit"]');
        const name = form.closest('product-page')?.querySelector('.product-info__title')?.textContent?.trim();
        this.add(new FormData(form), name, submit, form);
      }

      async add(body, name, trigger, form) {
        this.busy(trigger, true);
        try {
          let res;
          if (body instanceof FormData) {
            body.append('sections', SECTION);
            body.append('sections_url', window.location.pathname);
            res = await fetch(`${root()}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
          } else {
            res = await fetch(`${root()}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ ...body, sections: SECTION, sections_url: window.location.pathname })
            });
          }
          const data = await res.json();
          if (!res.ok) throw data;
          this.render(data.sections?.[SECTION]);
          this.added(name);
          if (!this.dialog.open) this.open(trigger);
          return data;
        } catch (err) {
          const msg = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
          if (form) {
            let box = form.querySelector('[data-cart-form-error]');
            if (!box) {
              box = document.createElement('p');
              box.className = 'cart-drawer__form-error';
              box.setAttribute('role', 'alert');
              box.dataset.cartFormError = '';
              form.appendChild(box);
            }
            box.textContent = msg;
          } else {
            this.error(msg);
          }
          throw err;
        } finally {
          this.busy(trigger, false);
        }
      }

      async change(key, quantity, trigger) {
        this.busy(trigger, true);
        try {
          const res = await fetch(`${root()}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity, sections: SECTION, sections_url: window.location.pathname })
          });
          const data = await res.json();
          if (!res.ok) throw data;
          this.render(data.sections?.[SECTION]);
          this.querySelector('.cart-drawer__x')?.focus();
        } catch (err) {
          this.error((err && err.description) || 'Something went wrong. Please try again.');
        } finally {
          this.busy(trigger, false);
        }
      }

      async refresh() {
        const res = await fetch(`${window.location.pathname}?sections=${SECTION}`);
        const data = await res.json();
        this.render(data[SECTION]);
      }

      render(html) {
        if (!html) return this.refresh();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-cart-content]');
        const current = this.querySelector('[data-cart-content]');
        if (fresh && current) current.replaceWith(fresh);
        this.bind();
        this.emit();
      }

      added(name) {
        const el = this.querySelector('[data-cart-added]');
        if (el && name) el.textContent = `${name} added`;
      }

      error(msg) {
        const el = this.querySelector('[data-cart-error]');
        if (!el) return;
        el.textContent = msg;
        el.hidden = false;
      }

      busy(el, on) {
        if (!el) return;
        el.toggleAttribute('aria-busy', on);
        if (on) el.setAttribute('disabled', '');
        else el.removeAttribute('disabled');
      }

      open(opener) {
        this.opener = opener || document.activeElement;
        if (!this.dialog.open) this.dialog.showModal();
        document.documentElement.classList.add('cart-drawer-open');
        requestAnimationFrame(() => this.dialog.classList.add('is-open'));
        this.querySelector('.cart-drawer__x')?.focus({ preventScroll: true });
      }

      close() {
        this.dialog.classList.remove('is-open');
        document.documentElement.classList.remove('cart-drawer-open');
        const done = () => {
          if (this.dialog.open) this.dialog.close();
          const added = this.querySelector('[data-cart-added]');
          if (added) added.textContent = '';
          this.opener?.focus?.({ preventScroll: true });
        };
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) done();
        else setTimeout(done, 280);
      }

      trap(e) {
        if (e.key !== 'Tab') return;
        const nodes = Array.from(
          this.dialog.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])')
        ).filter((n) => n.offsetParent !== null);
        if (!nodes.length) return;
        const first = nodes[0];
        const last = nodes[nodes.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    customElements.define('cart-drawer', CartDrawer);

    function money(cents, format) {
      const n = Number(cents) / 100;
      const whole = Math.round(n * 100) % 100 === 0;
      const num = n.toLocaleString('de-DE', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
      const f = format || '€{{amount_with_comma_separator}}';
      return f.replace(/\{\{\s*\w+\s*\}\}/, num);
    }
    window.PPMoney = money;

    class SavingsLine extends HTMLElement {
      connectedCallback() {
        try {
          this.prices = JSON.parse(this.querySelector('[data-savings-prices]').textContent);
        } catch (e) {
          this.prices = {};
        }
        this.text = this.querySelector('[data-savings-text]');
        this.base = this.text.textContent;
        this.form = this.closest('product-page')?.querySelector('[data-product-form]');
        document.addEventListener('pp:cart', (e) => this.update(e.detail));
        document.addEventListener('change', () => setTimeout(() => this.update(), 0));
        this.update();
      }

      price() {
        const id = this.form?.querySelector('[data-variant-id]')?.value;
        return Number(this.prices[id] ?? this.dataset.price);
      }

      update(state) {
        const s = state || window.PPCart?.state?.();
        if (!s) return;
        this.state = s;
        const top = s.pcts[s.pcts.length - 1];
        const tierFor = (amount) => s.amounts.reduce((acc, a, i) => (amount >= a ? s.pcts[i] : acc), 0);
        const list = this.querySelector('[data-savings-tiers]');
        if (list) list.innerHTML = s.amounts.map((a, i) => `<li>${money(a, s.moneyFormat)} · ${s.pcts[i]}%</li>`).join('');
        const p = this.price();
        let msg = `Collection savings: up to ${top}% when you build a set`;
        const isSet = this.dataset.set === 'true';
        if (s.qty > 0 || (s.count > 0 && isSet)) {
          const after = s.eligible + p;
          const qualifies = s.qty + 1 >= 2 || s.hasSet || isSet;
          const pctAfter = qualifies ? tierFor(after) : 0;
          const nextIndex = s.amounts.findIndex((a) => after < a);
          if (pctAfter > s.pct) msg = `With this piece you’ll reach ${pctAfter}%`;
          else if (s.pct >= top) msg = `Your order already has our highest collection saving, ${top}%`;
          else if (nextIndex > -1) msg = `With this piece you’ll be ${money(s.amounts[nextIndex] - after, s.moneyFormat)} away from ${s.pcts[nextIndex]}%`;
        } else if (isSet && tierFor(p) > 0) {
          msg = `This set on its own reaches ${tierFor(p)}%`;
        }
        this.text.textContent = msg;
      }
    }
    if (!customElements.get('savings-line')) customElements.define('savings-line', SavingsLine);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-bestsellers"]) return;
  try {
    
  if (!customElements.get('collection-type-filter')) {
    customElements.define(
      'collection-type-filter',
      class extends HTMLElement {
        connectedCallback() {
          this.visible = Number(this.dataset.visible) || 20;
          this.type = '';
          this.expanded = false;
          this.items = Array.from(this.querySelectorAll('li[data-type]'));
          this.buttons = Array.from(this.querySelectorAll('.type-filter__item'));
          this.more = this.querySelector('[data-more]');

          this.buttons.forEach((b) =>
            b.addEventListener('click', () => {
              this.type = b.dataset.type;
              this.expanded = false;
              this.buttons.forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
              this.render();
            })
          );
          this.more?.addEventListener('click', () => {
            this.expanded = true;
            this.render();
          });
        }

        render() {
          let shown = 0;
          let matching = 0;
          this.items.forEach((li) => {
            const match = !this.type || li.dataset.type === this.type;
            if (match) matching += 1;
            const show = match && (this.expanded || shown < this.visible);
            if (show) shown += 1;
            li.hidden = !show;
          });
          if (this.more) this.more.hidden = this.expanded || matching <= this.visible;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-hero"]) return;
  try {
    
  if (!customElements.get('shapes-sheet')) {
    customElements.define(
      'shapes-sheet',
      class extends HTMLElement {
        connectedCallback() {
          const dialog = this.querySelector('dialog');
          this.querySelector('[data-open]')?.addEventListener('click', () => dialog.showModal());
          this.querySelector('[data-close]')?.addEventListener('click', () => dialog.close());
          dialog.addEventListener('click', (e) => {
            if (e.target === dialog) dialog.close();
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-products"]) return;
  try {
    
  if (!customElements.get('show-more')) {
    customElements.define(
      'show-more',
      class extends HTMLElement {
        connectedCallback() {
          this.querySelector('[data-show-more]').addEventListener('click', () => {
            const grid = this.previousElementSibling;
            const step = parseInt(this.dataset.step, 10) || 15;
            const hidden = grid.querySelectorAll('li[data-more][hidden]');
            for (let i = 0; i < hidden.length && i < step; i++) hidden[i].hidden = false;
            if (hidden.length <= step) this.remove();
          });
        }
      }
    );
  }

  if (!customElements.get('load-more')) {
    customElements.define(
      'load-more',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-load-more]');
          this.button?.addEventListener('click', (e) => {
            e.preventDefault();
            this.load();
          });
        }

        async load() {
          const next = this.dataset.next;
          if (!next || this.busy) return;
          this.busy = true;
          this.button.setAttribute('aria-busy', 'true');
          try {
            const url = new URL(next, location.origin);
            url.searchParams.set('section_id', this.dataset.section);
            const html = await (await fetch(url)).text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const grid = this.closest('.collection-products').querySelector('[data-grid]');
            doc.querySelectorAll('[data-grid] > li').forEach((li) => grid.appendChild(li));
            const more = doc.querySelector('load-more');
            if (more) {
              this.dataset.next = more.dataset.next;
              this.button.href = more.dataset.next + '#shop';
            } else {
              this.remove();
            }
          } catch (err) {
            location.href = next + '#shop';
          } finally {
            this.busy = false;
            this.button?.removeAttribute('aria-busy');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  if (!customElements.get('show-more')) {
    customElements.define(
      'show-more',
      class extends HTMLElement {
        connectedCallback() {
          this.querySelector('[data-show-more]').addEventListener('click', () => {
            const grid = this.previousElementSibling;
            const step = parseInt(this.dataset.step, 10) || 15;
            const hidden = grid.querySelectorAll('li[data-more][hidden]');
            for (let i = 0; i < hidden.length && i < step; i++) hidden[i].hidden = false;
            if (hidden.length <= step) this.remove();
          });
        }
      }
    );
  }

  if (!customElements.get('collection-filters')) {
    class CollectionFilters extends HTMLElement {
      connectedCallback() {
        this.details = Array.from(this.querySelectorAll('[data-filter]'));
        this.details.forEach((item) => {
          item.addEventListener('toggle', () => {
            if (!item.open) return;
            this.details.forEach((other) => {
              if (other !== item) other.open = false;
            });
          });
        });

        this.onDocumentClick = (event) => {
          if (!this.contains(event.target)) this.details.forEach((item) => (item.open = false));
        };
        this.onKeyUp = (event) => {
          if (event.key !== 'Escape') return;
          const open = this.details.find((item) => item.open);
          if (open) {
            open.open = false;
            open.querySelector('summary').focus();
          }
        };
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keyup', this.onKeyUp);

        const sort = this.querySelector('[data-sort]');
        sort?.addEventListener('change', () => sort.form.submit());
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keyup', this.onKeyUp);
      }
    }
    customElements.define('collection-filters', CollectionFilters);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["color-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('color-gallery')) {
    customElements.define(
      'color-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.images = Array.from(this.querySelectorAll('.color-card__image'));
          this.current = 0;
          this.show(0);
          const next = this.querySelector('[data-next]');
          if (!next) return;
          next.addEventListener('click', () => this.show(this.current + 1));
          next.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.show(this.current + 1);
            }
          });
        }
        show(n) {
          if (!this.images.length) return;
          this.current = (n + this.images.length) % this.images.length;
          this.images.forEach((img, i) => img.classList.toggle('is-active', i === this.current));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    const btn = document.querySelector('[data-cookie-prefs]');
    if (!btn) return;
    const show = () => {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        btn.hidden = false;
        return true;
      }
      return false;
    };
    if (!show()) {
      let tries = 0;
      const t = setInterval(() => {
        if (show() || ++tries > 20) clearInterval(t);
      }, 500);
    }
    btn.addEventListener('click', () => window.privacyBanner && window.privacyBanner.showPreferences());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('header-menu')) {
    class HeaderMenu extends HTMLElement {
      connectedCallback() {
        this.details = Array.from(this.querySelectorAll('[data-nav-details]'));
        this.drawer = this.querySelector('.menu-drawer');
        this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

        this.details.forEach((item) => {
          item.addEventListener('toggle', () => {
            if (item.open) this.closeAll(item);
          });
          item.addEventListener('mouseenter', () => {
            if (!this.canHover.matches) return;
            clearTimeout(item._closeTimer);
            item.open = true;
          });
          item.addEventListener('mouseleave', () => {
            if (!this.canHover.matches) return;
            item._closeTimer = setTimeout(() => (item.open = false), 120);
          });
        });

        this.onKeyUp = (event) => {
          if (event.key !== 'Escape') return;
          const open = this.details.find((item) => item.open);
          if (open) {
            open.open = false;
            open.querySelector('summary').focus();
          }
        };
        this.onDocumentClick = (event) => {
          if (!this.contains(event.target)) this.closeAll();
        };
        document.addEventListener('keyup', this.onKeyUp);
        document.addEventListener('click', this.onDocumentClick);

        this.querySelector('[data-drawer-open]')?.addEventListener('click', () => this.drawer.showModal());
        this.querySelector('[data-drawer-close]')?.addEventListener('click', () => this.drawer.close());
        this.drawer?.addEventListener('click', (event) => {
          if (event.target === this.drawer) this.drawer.close();
        });
      }

      disconnectedCallback() {
        document.removeEventListener('keyup', this.onKeyUp);
        document.removeEventListener('click', this.onDocumentClick);
      }

      closeAll(except) {
        this.details.forEach((item) => {
          if (item !== except) item.open = false;
        });
      }
    }
    customElements.define('header-menu', HeaderMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slider')) {
    class HeroSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        if (this.slides.length < 2) return;

        this.current = 0;
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.dot), true)));

        // Phones, fit layout: each slide keeps its own height, so the banner
        // follows the slide on screen and slides change only when swiped.
        this.fitQuery = window.matchMedia('(max-width: 749px)');
        this.isFit = () => this.classList.contains('hero--fit') && this.fitQuery.matches;
        this.fitHeight = () => {
          this.track.style.height = this.isFit() ? `${this.slides[this.current].offsetHeight}px` : '';
        };
        this.fitObserver = new ResizeObserver(this.fitHeight);
        this.slides.forEach((slide) => this.fitObserver.observe(slide));
        this.fitQuery.addEventListener('change', this.fitHeight);
        this.fitHeight();
        this.classList.add('is-fit-ready');

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
                this.setCurrent(this.slides.indexOf(entry.target));
              }
            });
          },
          { root: this.track, threshold: [0.6] }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.pauseButton = this.querySelector('[data-pause]');
        if (this.dataset.autoplay === 'true' && !reducedMotion) {
          this.play();
          this.pauseButton?.addEventListener('click', () => (this.timer ? this.stop(true) : this.play()));
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('pointerenter', () => this.stop());
          this.addEventListener('pointerleave', () => {
            if (!this.userPaused) this.play();
          });
        } else if (this.pauseButton) {
          this.pauseButton.hidden = true;
        }
      }

      disconnectedCallback() {
        this.stop();
        this.fitObserver?.disconnect();
        this.observer?.disconnect();
      }

      setCurrent(index) {
        this.current = index;
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
        // Resize after the slide has finished scrolling in; resizing mid-scroll cancels it.
        clearTimeout(this.fitTimer);
        if (this.fitHeight) this.fitTimer = setTimeout(this.fitHeight, 450);
      }

      goTo(index, fromUser) {
        const slide = this.slides[index];
        if (!slide) return;
        this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        this.setCurrent(index);
        if (fromUser) this.stop(true);
      }

      play() {
        if (this.isFit?.()) {
          if (this.pauseButton) this.pauseButton.style.display = 'none';
          return;
        }
        this.userPaused = false;
        clearInterval(this.timer);
        this.timer = setInterval(() => this.goTo((this.current + 1) % this.slides.length), Number(this.dataset.speed) || 6000);
        if (this.pauseButton) {
          this.pauseButton.removeAttribute('data-paused');
          this.pauseButton.setAttribute('aria-label', this.pauseButton.dataset.labelPause);
        }
      }

      stop(byUser) {
        clearInterval(this.timer);
        this.timer = null;
        if (byUser) this.userPaused = true;
        if (this.pauseButton && byUser) {
          this.pauseButton.setAttribute('data-paused', '');
          this.pauseButton.setAttribute('aria-label', this.pauseButton.dataset.labelPlay);
        }
      }
    }
    customElements.define('hero-slider', HeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journal-standard"]) return;
  try {
    

if (!customElements.get('journal-layout')) {
  class JournalLayout extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.arrange(), { once: true });
      } else {
        this.arrange();
      }
    }
    arrange() {
      if (this.dataset.arranged === 'true') return;
      this.dataset.arranged = 'true';
      const article = this.closest('.pp-journal');
      const first = this.firstElementChild;
      if (!this.dataset.preserveIntro && first && first.tagName === 'P' && !first.querySelector('img,iframe,video')) {
        const intro = article.querySelector('.article-page__intro');
        if (intro) intro.append(first);
      }
      const nodes = Array.from(this.childNodes);
      let content = null;
      for (const node of nodes) {
        if (node.nodeType === 1 && /^(H2|H3)$/.test(node.tagName)) {
          const section = document.createElement('section');
          section.className = 'journal-layout-section';
          const label = document.createElement('div');
          label.className = 'journal-layout-label';
          content = document.createElement('div');
          content.className = 'journal-layout-content';
          this.insertBefore(section, node);
          label.append(node);
          section.append(label, content);
        } else if (node.nodeType === 1 && node.classList.contains('journal-video')) {
          // A video block stands between chapters on its own row.
          content = null;
        } else if (content) {
          content.append(node);
        }
      }

      const templates = Array.from(article.querySelectorAll('template[data-journal-product-images]'));
      for (const group of this.querySelectorAll('.journal-layout-content')) {
        const rows = Array.from(group.children).filter(el => el.classList.contains('journal-editorial-row'));
        if (!rows.length) continue;
        group.closest('.journal-layout-section').classList.add('journal-layout-section--products');
        const grid = document.createElement('div');
        grid.className = 'journal-product-grid';
        rows[0].before(grid);
        for (const row of rows) {
          const image = row.querySelector('img');
          const filename = image ? image.getAttribute('src').split('/').pop().split('?')[0] : '';
          const card = templates.find(t => t.dataset.journalProductImages.split('|').includes(filename));
          if (card) {
            grid.append(card.content.cloneNode(true));
            row.remove();
          } else {
            row.classList.add('journal-product-tile');
            const description = row.querySelector('.journal-editorial-row__text');
            const title = description?.querySelector('strong,b');
            if (title) { const name = document.createElement('p'); name.textContent = title.textContent; description.replaceChildren(name); }
            grid.append(row);
          }
        }
      }
    }
  }
  customElements.define('journal-layout', JournalLayout);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('gift-recipient')) {
    customElements.define(
      'gift-recipient',
      class extends HTMLElement {
        connectedCallback() {
          const toggle = this.querySelector('[data-recipient-toggle]');
          const box = this.querySelector('[data-recipient-fields]');
          const date = this.querySelector('[data-recipient-date]');
          const offset = this.querySelector('[data-recipient-offset]');
          if (date) date.min = new Date().toISOString().slice(0, 10);
          if (offset) offset.value = new Date().getTimezoneOffset();
          const sync = () => {
            box.hidden = !toggle.checked;
            box.querySelectorAll('input, textarea').forEach((el) => (el.disabled = !toggle.checked));
          };
          toggle.addEventListener('change', sync);
          sync();
          const name = this.querySelector('[data-design-name]');
          this.querySelectorAll('[data-design-index]').forEach((radio) => {
            radio.addEventListener('change', () => {
              if (name) name.textContent = radio.value;
              const thumb = this.closest('product-page')?.querySelector(`[data-gallery-thumb="${radio.dataset.designIndex}"]`);
              thumb?.click();
            });
          });
        }
      }
    );
  }

  if (!customElements.get('product-page')) {
    class ProductPage extends HTMLElement {
      connectedCallback() {
        const json = this.querySelector('[data-product-json]');
        this.data = json ? JSON.parse(json.textContent) : { variants: [] };

        this.track = this.querySelector('[data-gallery-track]');
        this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
        this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(Number(t.dataset.galleryThumb))));
        this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.goTo(this.index() - 1));
        this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.goTo(this.index() + 1));
        this.track?.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.markThumb(this.index()), 80);
        });

        this.form = this.querySelector('[data-product-form]');
        this.form?.addEventListener('change', (e) => {
          if (e.target.matches('[data-option-index]')) this.onOptionChange();
        });

        this.lightbox = this.querySelector('[data-lightbox]');
        this.querySelectorAll('[data-lightbox-open]').forEach((b) =>
          b.addEventListener('click', () => this.openLightbox(Number(b.dataset.lightboxOpen)))
        );
        this.querySelector('[data-lightbox-close]')?.addEventListener('click', () => this.lightbox.close());
        this.lightbox?.addEventListener('click', (e) => {
          if (e.target === this.lightbox) this.lightbox.close();
        });
        this.querySelectorAll('[data-lightbox-step]').forEach((b) =>
          b.addEventListener('click', () => this.stepLightbox(Number(b.dataset.lightboxStep)))
        );
        this.lightbox?.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') this.stepLightbox(1);
          if (e.key === 'ArrowLeft') this.stepLightbox(-1);
        });
      }

      slides() {
        return this.track ? Array.from(this.track.children) : [];
      }

      index() {
        if (!this.track) return 0;
        return Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1));
      }

      goTo(i) {
        const slides = this.slides();
        if (!slides.length) return;
        const n = (i + slides.length) % slides.length;
        this.track.scrollTo({ left: slides[n].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        this.markThumb(n);
      }

      markThumb(n) {
        this.thumbs.forEach((t, i) => t.setAttribute('aria-current', i === n ? 'true' : 'false'));
      }

      onOptionChange() {
        const groups = {};
        this.form.querySelectorAll('[data-option-index]:checked').forEach((i) => (groups[i.dataset.optionIndex] = i.value));
        const selected = Object.keys(groups).sort().map((k) => groups[k]);
        selected.forEach((v, i) => {
          const label = this.querySelector(`[data-option-value="${i}"]`);
          if (label) label.textContent = v;
        });
        const variant = this.data.variants.find((v) => v.options.every((o, i) => o === selected[i]));
        const submit = this.querySelector('[data-submit]');
        const submitLabel = this.querySelector('[data-submit-label]');
        if (!variant) {
          if (submit) submit.disabled = true;
          if (submitLabel) submitLabel.textContent = this.data.labels.unavailable;
          return;
        }
        this.querySelector('[data-variant-id]').value = variant.id;
        this.querySelectorAll('[data-price-current]').forEach((price) => {
          price.textContent = variant.price;
        });
        this.querySelectorAll('[data-price-compare]').forEach((compare) => {
          compare.hidden = !variant.compare;
          compare.textContent = variant.compare || '';
        });
        const weight = this.querySelector('[data-variant-weight]');
        if (weight && variant.weight) weight.textContent = variant.weight;
        if (submit) submit.disabled = !variant.available;
        if (submitLabel) submitLabel.textContent = variant.available ? this.data.labels.add : this.data.labels.soldOut;
        if (variant.media) {
          const slides = this.slides();
          const n = slides.findIndex((s) => s.dataset.mediaId == variant.media);
          if (n > -1) this.goTo(n);
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      stepLightbox(d) {
        const track = this.lightbox.querySelector('[data-lightbox-track]');
        const count = track.children.length;
        const current = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        const n = (current + d + count) % count;
        track.scrollTo({ left: track.children[n].offsetLeft, behavior: 'smooth' });
      }

      openLightbox(n) {
        if (!this.lightbox) return;
        this.lightbox.showModal();
        const track = this.lightbox.querySelector('[data-lightbox-track]');
        const slide = track.children[n];
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'instant' });
      }
    }
    customElements.define('product-page', ProductPage);
  }

  /* Kickflip shows one step at a time on phones and the colors are behind its
     arrow. This hint sits under the customizer and points to that arrow until
     the visitor first taps inside the customizer. The iframe is on another
     domain, so a tap there is detected by the window losing focus to it. */
  if (!customElements.get('customizer-hint')) {
    customElements.define(
      'customizer-hint',
      class extends HTMLElement {
        connectedCallback() {
          const mount = () => {
            const el = this.previousElementSibling;
            return el && el.matches('[data-kickflip-customizer]') ? el : null;
          };
          if (!mount()) return;
          try {
            if (sessionStorage.getItem('pp-customizer-used')) return;
          } catch (e) {}
          this.mq = window.matchMedia('(max-width: 749px)');
          this.update = () => {
            const ready = mount()?.querySelector('kickflip-customizer-iframe[iscustomizable="true"]');
            this.hidden = Boolean(this.used || !ready || !this.mq.matches);
          };
          this.onBlur = () => {
            setTimeout(() => {
              const active = document.activeElement;
              const el = mount();
              if (active && el && el.contains(active)) this.done();
            }, 0);
          };
          this.observer = new MutationObserver(this.update);
          // Kickflip can replace the mount element, so watch its parent.
          this.observer.observe(this.parentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['iscustomizable'] });
          this.mq.addEventListener('change', this.update);
          window.addEventListener('blur', this.onBlur);
          this.update();
        }

        done() {
          this.used = true;
          this.classList.add('is-done');
          try {
            sessionStorage.setItem('pp-customizer-used', '1');
          } catch (e) {}
          window.removeEventListener('blur', this.onBlur);
          setTimeout(() => (this.hidden = true), 400);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.mq?.removeEventListener('change', this.update);
          window.removeEventListener('blur', this.onBlur);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  if (!customElements.get('related-recommendations')) {
    customElements.define(
      'related-recommendations',
      class extends HTMLElement {
        connectedCallback() {
          if (this.children.length) return;
          fetch(this.dataset.url)
            .then((r) => r.text())
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const fresh = doc.querySelector('related-recommendations');
              if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
              else this.closest('.related-products')?.setAttribute('hidden', '');
            })
            .catch(() => {});
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["table-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('table-builder')) return;
    const COLORS = ['#e8382c', '#1d36c9', '#ffd900', '#8fd3ee'];
    const CREAM = '#f7f2e8';
    const LINE = { stroke: '#000', 'stroke-width': 1, 'vector-effect': 'non-scaling-stroke' };
    const L = (o) => Object.assign({}, o, LINE);
    const NS = 'http://www.w3.org/2000/svg';
    const DEFAULT_TIERS = [[30000, 3], [60000, 5], [100000, 7], [150000, 10], [200000, 12], [250000, 15]];

    const money = (c) => (window.PPMoney ? window.PPMoney(c) : '€' + Math.round(c / 100));
    const sizeOf = (t) => parseFloat(String(t || '').replace(/[^\d.]/g, '')) || 0;

    function rng(seed) {
      let s = seed % 2147483647 || 7;
      return () => ((s = (s * 16807) % 2147483647) - 1) / 2147483646;
    }
    function blob(cx, cy, r, seed, wobble = 0.09) {
      const rand = rng(seed);
      const n = 9;
      const pts = [];
      for (let i = 0; i < n; i++) {
        const a = (i / n) * Math.PI * 2;
        const rr = r * (1 + (rand() - 0.5) * 2 * wobble);
        pts.push([cx + Math.cos(a) * rr, cy + Math.sin(a) * rr]);
      }
      let d = '';
      for (let i = 0; i < n; i++) {
        const p0 = pts[i];
        const p1 = pts[(i + 1) % n];
        const mx = (p0[0] + p1[0]) / 2;
        const my = (p0[1] + p1[1]) / 2;
        d += (i === 0 ? `M${mx.toFixed(1)},${my.toFixed(1)}` : '') + ` Q${p1[0].toFixed(1)},${p1[1].toFixed(1)} ${((p1[0] + pts[(i + 2) % n][0]) / 2).toFixed(1)},${((p1[1] + pts[(i + 2) % n][1]) / 2).toFixed(1)}`;
      }
      return d + 'Z';
    }
    // Smooth closed path through points given in a local frame (x along the length).
    function shapePath(pts, cx, cy, r, rot, round = 0.5) {
      const c = Math.cos(rot);
      const sn = Math.sin(rot);
      const P = pts.map(([x, y]) => [cx + (x * c - y * sn) * r, cy + (x * sn + y * c) * r]);
      const n = P.length;
      const lerp = (p, q, t) => [p[0] + (q[0] - p[0]) * t, p[1] + (q[1] - p[1]) * t];
      const f = (p) => `${p[0].toFixed(1)},${p[1].toFixed(1)}`;
      // round = 0.5 gives a soft organic outline; smaller values keep straighter edges.
      let d = `M${f(lerp(P[0], P[1], round))}`;
      for (let i = 1; i <= n; i++) {
        const cur = P[i % n];
        const prev = P[i - 1];
        const next = P[(i + 1) % n];
        d += ` L${f(lerp(prev, cur, 1 - round))} Q${f(cur)} ${f(lerp(cur, next, round))}`;
      }
      return d + 'Z';
    }
    function el(name, attrs, parent) {
      const e = document.createElementNS(NS, name);
      for (const k in attrs) e.setAttribute(k, attrs[k]);
      if (parent) parent.appendChild(e);
      return e;
    }

    class TableBuilder extends HTMLElement {
      connectedCallback() {
        try {
          this.tiers = JSON.parse(this.dataset.savingsTiers || '[]');
        } catch (e) {
          this.tiers = [];
        }
        if (!this.tiers.length) this.tiers = DEFAULT_TIERS;
        try {
          this.pieces = JSON.parse(this.querySelector('[data-pieces-json]').textContent);
        } catch (e) {
          this.pieces = [];
        }
        this.state = {};
        this.pieces.forEach((p) => {
          const def = p.v.find((v) => v.t === p.def) || p.v[0];
          // qs holds a quantity per size, so one row can hold Ø28 and Ø35 together.
          // q reads and writes the quantity of the size currently selected.
          const st = { qs: {}, v: def ? def.id : null, c: null };
          // Keys combine size and colour, e.g. "4711|Sky Blue".
          Object.defineProperty(st, 'key', {
            get() {
              return `${this.v}|${this.c || ''}`;
            }
          });
          Object.defineProperty(st, 'q', {
            get() {
              return this.qs[this.key] || 0;
            },
            set(n) {
              this.qs[this.key] = n;
            }
          });
          this.state[p.id] = st;
        });
        this.svgLayer = this.querySelector('[data-pieces]');
        this.renderList();
        this.querySelectorAll('[data-preset]').forEach((b) => b.addEventListener('click', () => this.preset(b.dataset.preset)));
        this.querySelector('[data-add]').addEventListener('click', (e) => this.addToCart(e.currentTarget));
        const tiers = this.querySelector('[data-tiers]');
        tiers.innerHTML = this.tiers.map(([a, p], i) => `<li class="savings-bar__tier" style="left:${((i + 1) * 100) / this.tiers.length}%"><span class="savings-bar__dot"></span><span class="savings-bar__pct">${p}%</span><span class="savings-bar__amount">${a >= 100000 ? '€' + String(a / 100000).replace('.', ',') + 'k' : money(a)}</span></li>`).join('');
        this.preset('m', true);
      }

      total(p) {
        return Object.values(this.state[p.id].qs).reduce((a, b) => a + b, 0);
      }

      lines(p) {
        const s = this.state[p.id];
        return Object.entries(s.qs)
          .filter(([, q]) => q > 0)
          .map(([key, q]) => {
            const [id, c] = key.split('|');
            const hex = c && p.cols ? (p.cols.find(([n]) => n === c) || [])[1] : null;
            return { v: p.v.find((x) => x.id === Number(id)), q, c: c || null, hex };
          })
          .filter((l) => l.v);
      }

      variant(p) {
        return p.v.find((v) => v.id === this.state[p.id].v) || p.v[0];
      }

      renderList() {
        const list = this.querySelector('[data-list]');
        list.innerHTML = '';
        this.pieces.forEach((p) => {
          const li = document.createElement('li');
          li.className = 'tb-item';
          li.dataset.id = p.id;
          const sizes = p.v.length > 1
            ? `<div class="tb-sizes" role="group" aria-label="${p.label} size">${p.v.map((v) => `<button type="button" class="tb-size" data-size="${v.id}" ${v.a ? '' : 'disabled'}>${v.t.replace(' cm', '')}</button>`).join('')}</div>`
            : '';
          const colours = p.cols && p.cols.length
            ? `<div class="tb-colours" role="group" aria-label="${p.label} colour">${p.cols.map(([n, h]) => `<button type="button" class="tb-colour" data-colour="${n}" style="--c:${h}" aria-pressed="false"><span class="tb-colour__swatch"></span><span class="tb-colour__name">${n}</span></button>`).join('')}</div><span class="tb-hint" data-hint hidden>Choose a colour first</span>`
            : '';
          li.innerHTML = `
            <span class="tb-item__img">${p.img ? `<img src="${p.img}" alt="" loading="lazy" width="80" height="80">` : ''}</span>
            <span class="tb-item__text"><a href="${p.url}" class="tb-item__name">${p.label}</a><span class="tb-item__note">${p.note || ''}</span>${sizes}${colours}</span>
            <span class="tb-item__right">
              <span class="tb-item__price" data-price></span>
              <span class="tb-counter">
                <button type="button" class="tb-counter__btn" data-step="-1" aria-label="Remove one ${p.label}">−</button>
                <span class="tb-counter__q" data-q aria-live="polite">0</span>
                <button type="button" class="tb-counter__btn" data-step="1" aria-label="Add one ${p.label}">+</button>
              </span>
            </span>`;
          li.querySelectorAll('[data-step]').forEach((b) =>
            b.addEventListener('click', () => {
              const s = this.state[p.id];
              const step = Number(b.dataset.step);
              if (step > 0 && p.cols && p.cols.length && !s.c) {
                const hint = li.querySelector('[data-hint]');
                hint.hidden = false;
                li.querySelector('.tb-colour')?.focus();
                return;
              }
              s.q = Math.max(0, Math.min(4, s.q + step));
              this.update(p.id);
            })
          );
          li.querySelectorAll('[data-colour]').forEach((b) =>
            b.addEventListener('click', () => {
              const s = this.state[p.id];
              s.c = b.dataset.colour;
              if (s.q === 0) s.q = 1;
              li.querySelector('[data-hint]').hidden = true;
              this.update(p.id);
            })
          );
          li.querySelectorAll('[data-size]').forEach((b) =>
            b.addEventListener('click', () => {
              const s = this.state[p.id];
              s.v = Number(b.dataset.size);
              if (s.q === 0) s.q = 1;
              this.update(p.id);
            })
          );
          list.appendChild(li);
        });
      }

      preset(name, quiet) {
        const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];
        this.pieces.forEach((p) => {
          const s = this.state[p.id];
          if (name === 'clear') {
            s.qs = {};
            s.c = null;
          }
          else if (name === 'm' || name === 'l') {
            s.qs = {};
            const v = p.v.find((x) => x.t === p[name][1]);
            if (v) s.v = v.id;
            let qty = Number(p[name][0]) || 0;
            if (p.cols && p.cols.length) {
              const want = name === 'm' ? p.colm : p.coll;
              const hit = p.cols.find(([n]) => n === want);
              s.c = hit ? hit[0] : null;
              if (!s.c) qty = 0;
            }
            s.q = qty;
          } else if (name === 'surprise') {
            s.qs = {};
            const avail0 = p.v.filter((v) => v.a);
            if (avail0.length) s.v = pick(avail0).id;
            if (p.cols && p.cols.length) s.c = pick(p.cols)[0];
            s.q = p.place === 'center' ? (Math.random() < 0.45 ? 1 : 0) : Math.random() < 0.7 ? 1 : 0;
          }
        });
        if (name === 'surprise' && !this.pieces.some((p) => this.total(p) && p.place !== 'center')) {
          const first = this.pieces.find((p) => p.place !== 'center');
          if (first) this.state[first.id].q = 1;
        }
        this.seed = Math.floor(Math.random() * 100000) + 1;
        this.update(null, quiet);
      }

      update(changed, quiet) {
        let total = 0;
        let eligible = 0;
        let units = 0;
        let hasSet = false;
        this.pieces.forEach((p) => {
          const s = this.state[p.id];
          const v = this.variant(p);
          const li = this.querySelector(`.tb-item[data-id="${p.id}"]`);
          li.classList.toggle('is-on', this.total(p) > 0);
          li.querySelector('[data-q]').textContent = s.q;
          li.querySelector('[data-price]').textContent = v ? money(v.p) : '';
          li.querySelectorAll('[data-size]').forEach((b) => {
            const n = Object.entries(s.qs).filter(([key]) => key.split('|')[0] === b.dataset.size).reduce((t, [, q]) => t + q, 0);
            b.setAttribute('aria-pressed', String(Number(b.dataset.size) === s.v));
            b.classList.toggle('has-qty', n > 0);
            b.dataset.n = n > 1 ? `×${n}` : '';
          });
          li.querySelectorAll('[data-colour]').forEach((b) => {
            const n = s.qs[`${s.v}|${b.dataset.colour}`] || 0;
            b.setAttribute('aria-pressed', String(b.dataset.colour === s.c));
            b.classList.toggle('has-qty', n > 0);
            b.dataset.n = n > 1 ? `×${n}` : '';
          });
          this.lines(p).forEach((l) => {
            total += l.v.p * l.q;
            if (!p.sale) {
              eligible += l.v.p * l.q;
              units += l.q;
              if (p.set) hasSet = true;
            }
          });
        });
        const qualifies = units > 1 || hasSet;
        let pct = 0;
        let next = null;
        this.tiers.forEach(([a, p]) => {
          if (eligible >= a) pct = p;
          else if (!next) next = [a, p];
        });
        if (!qualifies) pct = 0;
        this.querySelector('[data-total]').textContent = money(total);
        const saving = this.querySelector('[data-saving]');
        if (total === 0) saving.textContent = 'Choose a few pieces to begin.';
        else if (!qualifies) saving.textContent = 'Add one more piece to start collection savings.';
        else if (pct && !next) saving.textContent = `Collection saving ${pct}%: −${money(Math.round((eligible * pct) / 100))}. Our highest tier.`;
        else if (pct) saving.textContent = `Collection saving ${pct}%: −${money(Math.round((eligible * pct) / 100))}. Add ${money(next[0] - eligible)} more for ${next[1]}%.`;
        else saving.textContent = `Add ${money(next[0] - eligible)} more to save ${next[1]}%.`;
        let fill = 0;
        let prev = 0;
        const step = 100 / this.tiers.length;
        for (const [a] of this.tiers) {
          if (eligible >= a) fill += step;
          else {
            fill += Math.max(0, ((eligible - prev) / (a - prev)) * step);
            break;
          }
          prev = a;
        }
        this.querySelector('[data-fill]').style.width = fill + '%';
        this.querySelectorAll('[data-tiers] li').forEach((li, i) => li.classList.toggle('is-reached', qualifies && eligible >= this.tiers[i][0]));
        this.querySelector('[data-add]').disabled = total === 0;
        this.draw(changed);
      }

      draw(changed) {
        const g = this.svgLayer;
        g.innerHTML = '';
        const seed = this.seed || 11;
        const setting = [];
        const center = [];
        this.pieces.forEach((p) => {
          const s = this.state[p.id];
          this.lines(p).forEach((l) => {
            const units = l.q * (Number(p.per) || 1);
            const cm = sizeOf(l.v.t) || Number(p.cm) || 20;
            (p.place === 'center' ? center : setting).push({ p, units, q: l.q, cm, hex: l.hex, fresh: p.id === changed && l.v.id === s.v && l.c === s.c });
          });
        });
        const seats = Math.min(16, Math.max(0, ...setting.map((x) => Math.min(x.units, 16))));
        this.querySelector('[data-empty]').style.display = setting.length || center.length ? 'none' : '';
        const pieces = [...setting, ...center].reduce((n, x) => n + x.units, 0);
        this.querySelector('[data-count]').textContent = pieces ? `${pieces} pieces${seats ? ` · a table for ${seats}` : ''}` : '';

        // True scale: about 4.6 px per cm on a table for four. If the shared
        // pieces do not fit in the middle, everything shrinks a little.
        const TABLE = 304;
        const flat = setting.filter((x) => !['tumbler', 'mug', 'deep'].includes(x.p.shape)).sort((a, b) => b.cm - a.cm);
        const sides = setting.filter((x) => x.p.shape === 'deep');
        const cups = setting.filter((x) => ['tumbler', 'mug'].includes(x.p.shape));
        const units = [];
        center.forEach((x) => {
          for (let u = 0; u < x.units; u++) units.push({ ...x, u });
        });
        units.sort((a, b) => b.cm - a.cm);
        const angOf = (i) => (i / seats) * Math.PI * 2 - Math.PI / 2 + (seats === 2 ? Math.PI / 2 : 0);
        // Fewer pieces than seats: spread them evenly round the table.
        const atSeat = (x, i) => {
          const u = Math.min(x.units, seats);
          if (u >= seats) return true;
          for (let j = 0; j < u; j++) if (Math.floor((j * seats) / u) === i) return true;
          return false;
        };
        const unitAt = (x, i) => {
          let n = 0;
          for (let s2 = 0; s2 < i; s2++) if (atSeat(x, s2)) n++;
          return n;
        };
        // A deep plate sits at the diner's left, beside the plate.
        const sidePos = (i, j, rr, R, plateR) => {
          const a = angOf(i);
          const sx = 320 + Math.cos(a) * R;
          const sy = 320 + Math.sin(a) * R;
          const along = -(plateR * 0.62 + rr * 0.78 + j * (rr * 1.6));
          const inward = plateR * 0.42;
          return [sx + Math.sin(a) * along - Math.cos(a) * inward, sy - Math.cos(a) * along - Math.sin(a) * inward];
        };
        // A cup stands at the diner's top right, beside the plate.
        const cupPos = (i, j, cr, R, plateR) => {
          const a = angOf(i);
          const sx = 320 + Math.cos(a) * R;
          const sy = 320 + Math.sin(a) * R;
          const tx = Math.sin(a);
          const ty = -Math.cos(a);
          const along = plateR * 0.78 + cr * 0.55 + j * (cr * 2 + 4);
          const inward = plateR * 0.78;
          return [sx + tx * along - Math.cos(a) * inward, sy + ty * along - Math.sin(a) * inward];
        };
        const layout = (k) => {
          const plateR = flat.length ? (flat[0].cm / 2) * k : sides.length ? (sides[0].cm / 2) * k : cups.length ? 30 : 0;
          const R = TABLE - plateR - 14;
          // Each seat needs room for its plate, a deep plate on the left and cups.
          if (seats > 1) {
            const seatW = (flat.length ? plateR * 2 : 0) + (sides.length ? sides[0].cm * k * 0.85 : 0) + (cups.length ? cups[0].cm * k * 0.6 : 0);
            if (seatW > ((2 * Math.PI * R) / seats) * 0.98) return null;
          }
          // Everything already at the seats is an obstacle; shared pieces use
          // whatever room is left on the table, middle first.
          const placed = [];
          for (let i = 0; i < seats; i++) {
            const ang = angOf(i);
            if (flat.length) placed.push({ x: 320 + Math.cos(ang) * R, y: 320 + Math.sin(ang) * R, r: plateR });
            cups.forEach((x, j) => {
              if (!atSeat(x, i)) return;
              const cr = (x.cm / 2) * k;
              const [px, py] = cupPos(i, j, cr, R, plateR);
              placed.push({ x: px, y: py, r: cr });
            });
            sides.forEach((x, j) => {
              if (!atSeat(x, i)) return;
              const rr = (x.cm / 2) * k;
              const [px, py] = flat.length ? sidePos(i, j, rr, R, plateR) : [320 + Math.cos(ang) * R, 320 + Math.sin(ang) * R];
              placed.push({ x: px, y: py, r: rr });
            });
          }
          const fixed = placed.length;
          const fits = (px, py, r, list) => Math.hypot(px - 320, py - 320) + r <= TABLE - 10 && list.every((q) => Math.hypot(q.x - px, q.y - py) >= q.r + r + 6);
          const group = [];
          const centroid = (list) => {
            const w = list.reduce((t, q) => t + q.r * q.r, 0) || 1;
            return [list.reduce((t, q) => t + q.x * q.r * q.r, 0) / w, list.reduce((t, q) => t + q.y * q.r * q.r, 0) / w];
          };
          for (let n = 0; n < units.length; n++) {
            const x = units[n];
            const isLong = ['tray', 'trio', 'butter'].includes(x.p.shape);
            const draw = (x.cm / 2) * k * (x.cm >= 20 ? 1.2 : 1.1);
            const r = isLong ? draw * 0.95 : draw;
            // Choose the spot that keeps the whole group's weight closest to the
            // middle of the table, and the group itself compact.
            let best = null;
            let bestScore = Infinity;
            for (let px = 24; px <= 616; px += 6) {
              for (let py = 24; py <= 616; py += 6) {
                if (!fits(px, py, r, placed)) continue;
                const cand = { x: px, y: py, r };
                const [gx, gy] = centroid([...group, cand]);
                const near = group.length ? Math.min(...group.map((q) => Math.hypot(q.x - px, q.y - py) - q.r - r)) : 0;
                const score = Math.hypot(gx - 320, gy - 320) * 2 + Math.hypot(px - 320, py - 320) * 0.35 + Math.max(0, near) * 0.8;
                if (score < bestScore) {
                  bestScore = score;
                  best = { x: px, y: py, r, draw, unit: x, n };
                }
              }
            }
            if (!best) return null;
            placed.push(best);
            group.push(best);
          }
          // Finally nudge the whole group so its weight sits on the centre.
          if (group.length) {
            const others = placed.slice(0, fixed);
            const [cx, cy] = centroid(group);
            let bestShift = [0, 0];
            let bestD = Math.hypot(cx - 320, cy - 320);
            for (let dx = -90; dx <= 90; dx += 5) {
              for (let dy = -90; dy <= 90; dy += 5) {
                const d = Math.hypot(cx + dx - 320, cy + dy - 320);
                if (d >= bestD) continue;
                const moved = group.map((q) => ({ x: q.x + dx, y: q.y + dy, r: q.r }));
                if (moved.every((q) => fits(q.x, q.y, q.r, others))) {
                  bestD = d;
                  bestShift = [dx, dy];
                }
              }
            }
            group.forEach((q) => {
              q.x += bestShift[0];
              q.y += bestShift[1];
            });
          }
          return { k, plateR, R, placed: placed.slice(fixed) };
        };
        let k = seats > 12 ? 2.1 : seats > 10 ? 2.6 : seats > 8 ? 3 : seats > 6 ? 3.4 : seats > 4 ? 3.9 : 4.6;
        let L0 = layout(k);
        for (let tries = 0; !L0 && tries < 30; tries++) {
          k *= 0.95;
          L0 = layout(k);
        }
        if (!L0) L0 = { k, plateR: 0, R: TABLE - 60, placed: [] };
        const R = L0.R;
        for (let i = 0; i < seats; i++) {
          const ang = angOf(i);
          const cx = 320 + Math.cos(ang) * R;
          const cy = 320 + Math.sin(ang) * R;
          let layer = 0;
          flat.forEach((x) => {
            if (!atSeat(x, i)) return;
            this.piece(g, x.p.shape, cx, cy, (x.cm / 2) * k, COLORS[(unitAt(x, i) + layer * 3) % 4], seed + i * 31 + layer * 7, x.fresh);
            layer++;
          });
          sides.forEach((x, j) => {
            if (!atSeat(x, i)) return;
            const rr = (x.cm / 2) * k;
            const [px, py] = flat.length ? sidePos(i, j, rr, R, L0.plateR) : [cx, cy];
            this.piece(g, x.p.shape, px, py, rr, COLORS[(unitAt(x, i) + 2) % 4], seed + i * 17 + j, x.fresh);
          });
          cups.forEach((x, j) => {
            if (!atSeat(x, i)) return;
            const cr = (x.cm / 2) * k;
            const [px, py] = cupPos(i, j, cr, R, L0.plateR);
            this.piece(g, x.p.shape, px, py, cr, COLORS[(unitAt(x, i) + 1 + j) % 4], seed + i * 13 + j, x.fresh);
          });
        }
        L0.placed.forEach((q) => {
          const x = q.unit;
          this.piece(g, x.p.shape, q.x, q.y, q.draw, x.hex || COLORS[(q.n + 2) % 4], seed + 500 + q.n, x.fresh && x.u === x.units - 1);
        });
      }

      piece(g, shape, cx, cy, r, color, seed, fresh) {
        const grp = el('g', { class: 'tb-piece' + (fresh ? ' is-new' : ''), filter: 'url(#tbShadow)' }, g);
        grp.style.transformOrigin = `${cx}px ${cy}px`;
        if (shape === 'tumbler' || shape === 'mug') {
          if (shape === 'mug') el('rect', L({ x: cx + r * 0.95, y: cy - r * 0.22, width: r * 0.7, height: r * 0.44, fill: CREAM }), grp);
          el('path', L({ d: blob(cx, cy, r * 1.14, seed + 1, 0.05), fill: CREAM }), grp);
          el('path', { d: blob(cx, cy, r, seed, 0.06), fill: color }, grp);
          el('path', L({ d: blob(cx, cy, r * 0.62, seed + 3, 0.05), fill: CREAM }), grp);
          return;
        }
        if (shape === 'oil') {
          el('circle', L({ cx: cx - r * 0.8, cy, r, fill: CREAM }), grp);
          el('circle', L({ cx: cx - r * 0.8, cy, r: r * 0.45, fill: COLORS[1] }), grp);
          el('circle', L({ cx: cx + r * 0.9, cy: cy + 3, r, fill: CREAM }), grp);
          el('circle', L({ cx: cx + r * 0.9, cy: cy + 3, r: r * 0.45, fill: COLORS[0] }), grp);
          return;
        }
        if (shape === 'shaker') {
          el('path', L({ d: blob(cx - r * 0.75, cy, r, seed, 0.08), fill: COLORS[2] }), grp);
          el('circle', L({ cx: cx - r * 0.75, cy, r: r * 0.18, fill: '#000' }), grp);
          el('path', L({ d: blob(cx + r * 0.8, cy + 2, r, seed + 4, 0.08), fill: COLORS[3] }), grp);
          el('circle', L({ cx: cx + r * 0.8 - r * 0.25, cy: cy + 2, r: r * 0.12, fill: '#000' }), grp);
          el('circle', L({ cx: cx + r * 0.8 + r * 0.25, cy: cy + 2, r: r * 0.12, fill: '#000' }), grp);
          return;
        }
        if (shape === 'butter') {
          const rot = 0.25 + ((seed % 5) - 2) * 0.06;
          const base = [[-1, -0.05], [-0.82, -0.52], [-0.1, -0.66], [0.75, -0.5], [1.02, 0.02], [0.8, 0.52], [0.05, 0.64], [-0.78, 0.48]];
          const lid = [[-0.74, -0.06], [-0.6, -0.4], [0, -0.48], [0.6, -0.38], [0.76, 0.04], [0.6, 0.4], [0, 0.46], [-0.62, 0.36]];
          el('path', L({ d: shapePath(base, cx, cy, r, rot), fill: CREAM }), grp);
          el('path', L({ d: shapePath(lid, cx, cy, r, rot), fill: color }), grp);
          el('path', { d: shapePath([[-0.5, -0.24], [0, -0.32], [0.42, -0.24], [0.2, -0.12], [-0.3, -0.12]], cx, cy, r, rot), fill: 'rgba(255,255,255,.28)' }, grp);
          el('path', L({ d: blob(cx, cy, r * 0.17, seed + 3, 0.18), fill: color }), grp);
          el('path', { d: blob(cx - r * 0.04, cy - r * 0.05, r * 0.07, seed + 4, 0.2), fill: 'rgba(255,255,255,.45)' }, grp);
          return;
        }
        if (shape === 'trio') {
          el('path', L({ d: blob(cx, cy, r, seed + 2, 0.1), fill: CREAM, transform: `translate(${cx} ${cy}) scale(1 0.62) translate(${-cx} ${-cy})` }), grp);
          el('path', { d: blob(cx - r * 0.1, cy, r * 0.8, seed, 0.14), fill: color, transform: `translate(${cx} ${cy}) scale(1 0.5) translate(${-cx} ${-cy})` }, grp);
          el('path', L({ d: blob(cx - r * 0.35, cy, r * 0.48, seed + 4, 0.06), fill: CREAM }), grp);
          el('path', { d: blob(cx - r * 0.35, cy, r * 0.34, seed + 6, 0.12), fill: COLORS[(COLORS.indexOf(color) + 2) % 4] }, grp);
          el('path', L({ d: blob(cx + r * 0.52, cy + r * 0.05, r * 0.2, seed + 8, 0.06), fill: CREAM }), grp);
          el('path', { d: blob(cx + r * 0.52, cy + r * 0.05, r * 0.13, seed + 9, 0.1), fill: COLORS[(COLORS.indexOf(color) + 1) % 4] }, grp);
          return;
        }
        if (shape === 'tray') {
          const rot = -0.45 + ((seed % 7) - 3) * 0.04;
          const body = [[-1.02, -0.2], [-0.72, -0.5], [-0.1, -0.5], [0.62, -0.38], [1.02, 0.02], [0.78, 0.42], [0.1, 0.5], [-0.62, 0.36]];
          const yellow = [[-0.98, -0.18], [-0.7, -0.44], [-0.32, -0.42], [-0.3, -0.08], [-0.52, 0.16], [-0.86, 0.12]];
          const blue = [[-0.34, -0.3], [0.2, -0.42], [0.66, -0.3], [0.94, 0.04], [0.72, 0.36], [0.12, 0.42], [-0.3, 0.24], [-0.42, -0.02]];
          el('path', L({ d: shapePath(body, cx, cy, r, rot, 0.24), fill: CREAM }), grp);
          el('path', { d: shapePath(yellow, cx, cy, r, rot, 0.4), fill: COLORS[2] }, grp);
          el('path', L({ d: shapePath(blue, cx, cy, r, rot, 0.42), fill: '#16259b' }), grp);
          return;
        }
        // Plates, deep plates, bowls, salad bowl: cream body with a colour field.
        el('path', L({ d: blob(cx, cy, r, seed, shape === 'bowl' ? 0.05 : 0.07), fill: CREAM }), grp);
        const off = shape === 'bowl' || shape === 'salad' ? 0 : r * 0.07;
        el('path', { d: blob(cx - off, cy + off * 0.4, r * (shape === 'bowl' ? 0.7 : 0.74), seed + 5, 0.12), fill: color }, grp);
        if (shape === 'deep' || shape === 'bowl' || shape === 'salad') {
          el('path', { d: blob(cx, cy, r * 0.42, seed + 8, 0.12), fill: 'none', stroke: 'rgba(0,0,0,.2)', 'stroke-width': 1, 'vector-effect': 'non-scaling-stroke' }, grp);
        }
      }

      async addToCart(btn) {
        const items = [];
        this.pieces.forEach((p) => {
          const s = this.state[p.id];
          this.lines(p).forEach(({ v, q, c }) => {
          if (!v.a) return;
          const props = {};
          if (c) props[p.ckey || 'Glaze'] = c;
          if (p.prop && p.prop.includes(':')) {
            const [k, ...rest] = p.prop.split(':');
            props[k.trim()] = rest.join(':').trim();
          }
          const hasProps = Object.keys(props).length > 0;
          const same = items.find((i) => i.id === v.id && JSON.stringify(i.properties || {}) === JSON.stringify(props));
          if (same) same.quantity += q;
          else items.push(hasProps ? { id: v.id, quantity: q, properties: props } : { id: v.id, quantity: q });
          // (several colours of one product become separate cart lines)
          });
        });
        if (!items.length) return;
        const err = this.querySelector('[data-error]');
        err.hidden = true;
        try {
          if (window.PPCart) {
            await window.PPCart.add({ items }, 'Your BAUHAUS table', btn);
          } else {
            const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
            if (!r.ok) throw await r.json();
            window.location.href = '/cart';
          }
        } catch (e) {
          err.textContent = (e && (e.description || e.message)) || 'Something went wrong. Please try again.';
          err.hidden = false;
        }
      }
    }
    customElements.define('table-builder', TableBuilder);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["withdrawal-form"]) return;
  try {
    
  (function () {
    const form = document.getElementById('WithdrawalForm');
    if (!form) return;
    const KEY = 'pp-withdrawal';
    form.addEventListener('submit', () => {
      const data = [];
      form.querySelectorAll('input:not([type=hidden]), textarea').forEach((el) => {
        const label = form.querySelector(`label[for="${el.id}"]`);
        if (el.value.trim()) data.push([label ? label.textContent.replace(' *', '') : el.name, el.value.trim()]);
      });
      data.push(['Sent on', new Date().toLocaleString()]);
      try {
        sessionStorage.setItem(KEY, JSON.stringify(data));
      } catch (e) {}
    });
    const summary = form.querySelector('[data-summary]');
    if (summary) {
      let data = null;
      try {
        data = JSON.parse(sessionStorage.getItem(KEY));
      } catch (e) {}
      if (data && data.length) {
        data.forEach(([k, v]) => {
          const dt = document.createElement('dt');
          dt.textContent = k;
          const dd = document.createElement('dd');
          dd.textContent = v;
          summary.append(dt, dd);
        });
        summary.hidden = false;
      }
      form.querySelector('[data-print]')?.addEventListener('click', () => window.print());
      form.querySelector('.withdrawal__done')?.focus();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
